module.exports = __webpack_public_path__ + "img/coins.d2f8ef1c.png";